import { render, staticRenderFns } from "./style4.vue?vue&type=template&id=07220738&scoped=true&"
import script from "./style4.vue?vue&type=script&lang=js&"
export * from "./style4.vue?vue&type=script&lang=js&"
import style0 from "./style4.vue?vue&type=style&index=0&id=07220738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07220738",
  null
  
)

export default component.exports